import './i18n'; // Initialize i18next globally
import ClientModulesProvider from './app/_providers/ClientModulesProvider';
import ReactQueryProvider from './app/_providers/ReactQueryProvider';
import TanStackRouterProvider from './app/_providers/TanStackRouterProvider';

export default function App() {
  return (
    <ClientModulesProvider>
      <ReactQueryProvider>
        <TanStackRouterProvider />
      </ReactQueryProvider>
    </ClientModulesProvider>
  );
}
